<template>
  <iconsWrapper :width="width" :height="height" :viewBox="viewBox" class="icon">
    <path
      d="M13.2599 3.60022L5.04985 12.2902C4.73985 12.6202 4.43985 13.2702 4.37985 13.7202L4.00985 16.9602C3.87985 18.1302 4.71985 18.9302 5.87985 18.7302L9.09985 18.1802C9.54985 18.1002 10.1799 17.7702 10.4899 17.4302L18.6999 8.74022C20.1199 7.24022 20.7599 5.53022 18.5499 3.44022C16.3499 1.37022 14.6799 2.10022 13.2599 3.60022Z"
      :stroke="iconColor"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
      fill="none"
    />
    <path
      d="M12 5C12.43 7.76 14.67 9.87 17.45 10.15"
      :stroke="iconColor"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </iconsWrapper>
</template>

<script>
import iconsWrapper from '@/components/icons/iconsWrapper.vue';
export default {
  name: 'IconEditPen',
  components: {
    iconsWrapper,
  },
  props: {
    iconColor: {
      type: String,
      default: 'currentColor',
    },
    width: {
      type: [Number, String],
      default: 22,
    },
    height: {
      type: [Number, String],
      default: 22,
    },
    viewBox: {
      type: String,
      default: '0 0 22 22',
    },
  },
};
</script>

<style scoped>
.icon-wrapper {
  display: inline-block;
  cursor: pointer;
  --icon-hover: #153878;
  --primary: #012464;
  color: var(--primary);
  transition: color 0.3s ease;
}

.icon-wrapper:hover {
  color: var(--icon-hover);
}
</style>
